import { render } from "./BlFormFieldValidationselector.vue?vue&type=template&id=b502eaf6&scoped=true"
import script from "./BlFormFieldValidationselector.vue?vue&type=script&lang=js"
export * from "./BlFormFieldValidationselector.vue?vue&type=script&lang=js"

import "./BlFormFieldValidationselector.vue?vue&type=style&index=0&id=b502eaf6&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b502eaf6"]])

export default __exports__